<template>
  <div class="box summary-boxes-border">
    <div class="columns">
      <div class="column" v-if="isCompanionUser">
        <SummaryBox label="Companion" :value="usage.companion" :image="false" />
      </div>
      <div class="column" v-if="hasAutoCheck">
        <SummaryBox
          label="AutoChecks"
          :value="usage.autocheck"
          icon-color="summary-box-icon-color"
          icon-class=""
        />
      </div>
      <div class="column">
        <SummaryBox
          label="Vehicle Profile"
          :value="usage.vpp"
          icon-color="summary-box-icon-color"
          icon-class=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountHistorySummaryBoxes',
  components: {
    SummaryBox: () => import('core/components/SummaryBox')
  },
  props: {
    usage: {
      type: Object,
      required: true
    },
    isCompanionUser: {
      type: Number,
      required: true
    },
    hasAutoCheck: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="sass">
.summary-boxes-border
  background-color: $summary-boxes-border

.summary-box-icon-color
  color: $summary-box-icon-color !important
</style>
